<script lang="ts">
import { ChartOptions } from "chart.js";
import { Line, mixins } from "vue-chartjs";
import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
  extends: Line,
  mixins: [mixins.reactiveProp],
})
export default class CampaignsGraphLine extends Mixins(mixins.reactiveProp, Line) {
  @Prop() readonly options!: ChartOptions;

  mounted(): void {
    window.addEventListener("resize", this.onResize);
    this.refreshChart();
  }

  refreshChart(): void {
    if (!this.$refs.canvas) {
      return;
    }
    this.renderChart(this.chartData, this.options);
  }

  onResize(e: Event) {
    this.refreshChart();
  }
}
</script>
